import StrokedCopyIcon from '@/components/icons/StrokedCopyIcon.vue';
import ClearIcon from '@/components/icons/ClearIcon.vue';
import EvolutionChartController from '@/components/EvolutionChartController.vue';
import BarChartIcon from "@/components/icons/BarChartIcon.vue";
import LineChartIcon from '@/components/icons/LineChartIcon.vue';
import BarLineChartIcon from "@/components/icons/BarLineChartIcon.vue";
import ChartsMixin from '../mixins/ChartsMixin.vue';
import moment from 'moment';
import AppDropdown from '@/components/AppDropdown.vue';
import ChartThemeDropdown from '@/components/ChartThemeDropdown.vue';
import EvolutionChartFooterItem from '@/components/EvolutionChartFooterItem.vue';
import SwitchVerticalIcon from "@/components/icons/SwitchVerticalIcon.vue";
import AlignTopIcon from '@/components/icons/AlignTopIcon.vue';
import EvolutionChartExportModal from '@/components/EvolutionChartExportModal.vue';
import { copyHTMLNodeIntoAnother } from "@/utils/index.js";
import AppButton from "@/components/AppButton.vue";
import { CHART_EXPORT_DATE_FORMATS, EVENTS } from '@/utils/constants';
export default {
  name: "EvolutionChartModal",
  components: {
    StrokedCopyIcon,
    ClearIcon,
    EvolutionChartController,
    BarChartIcon,
    LineChartIcon,
    BarLineChartIcon,
    AppDropdown,
    ChartThemeDropdown,
    EvolutionChartFooterItem,
    SwitchVerticalIcon,
    AlignTopIcon,
    EvolutionChartExportModal,
    AppButton
  },
  mixins: [ChartsMixin],
  data() {
    return {
      icons: {
        "line-chart": LineChartIcon,
        "bar-chart": BarChartIcon,
        "bar-line-chart": BarLineChartIcon
      },
      exporting: false,
      exportModal: false,
      showExportAxes: false
    };
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    comparePoints: {
      type: Number,
      default: 2
    },
    options: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
    periodEndOf: {
      type: String
    },
    chartEngine: {
      type: Object
    },
    openedEventName: {
      type: String,
      default: "dashboardPlotOpened"
    }
  },
  emits: ["update:modelValue", "modal-shown", "rechart", "export", "refresh-chart", "resize"],
  computed: {
    modal: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      }
    },
    metric1: {
      get() {
        return this.chartEngine._metric1;
      },
      set(v) {
        this.chartEngine.metric1 = v;
        // this.$emit('rechart', [v, this.metric2]);
      }
    },
    metric2: {
      get() {
        return this.chartEngine._metric2;
      },
      set(v) {
        this.chartEngine.metric2 = v;
        // this.$emit('rechart', [this.metric1, v])
      }
    },
    metric1Evolution: {
      get() {
        return this.metric1.evolution.type;
      },
      set(v) {
        this.metric1.evolution.set(v);
      }
    },
    chartPeriod() {
      return this.chartEngine?.chartPeriod;
    },
    flattenedOptions() {
      return Object.entries(this.options);
    },
    dateRange() {
      if (!this.items || this.items.length === 0) return null;
      const startDate = moment(this.items[0].period_agg).format('DD MMM');
      const lastItemDate = moment(this.items[this.items.length - 1].period_agg);
      console.log("Period end of", this.periodEndOf);
      const endOfPeriod = moment(lastItemDate).endOf(this.periodEndOf); // Ensure a new moment object for endOf

      const yesterday = moment().subtract(1, 'days').endOf('day');
      const endDate = moment.min(yesterday, endOfPeriod).format('DD MMM YYYY');
      return `${startDate} - ${endDate}`;
    }
  },
  methods: {
    selectChart(key) {
      this.chartEngine.chartType = key;
    },
    onModalShown() {
      this.$nextTick(() => {
        this.$emit('modal-shown'); // 🔥 notify child
        window.$bus.trigger(EVENTS.MIXPANEL_TRACK, {
          event_name: this.openedEventName,
          properties: {}
        });
      });
    },
    generateChartFileName() {
      let fileNameParts = [];
      fileNameParts.push(this.metric1?.label);
      fileNameParts.push(this.metric2?.label);
      if (fileNameParts.length === 0) {
        return 'chart.png'; // Fallback if neither metric is available
      }
      return `${fileNameParts.filter(Boolean).join('_')}_chart.png`;
    },
    async handleExport(options = {
      width: 0,
      height: 0
    }) {
      this.exporting = true;
      try {
        const {
          width,
          height,
          limit
        } = options;
        const exportEngine = this.chartEngine.clone({
          dateFormats: CHART_EXPORT_DATE_FORMATS,
          forceShowAxes: this.showExportAxes
        });
        let chartConfig = limit ? exportEngine.limit(limit) : exportEngine._lastChartConfig;
        chartConfig = {
          ...chartConfig,
          options: {
            ...chartConfig.options,
            layout: {
              padding: {
                left: 10,
                right: 10,
                top: 5,
                bottom: 20
              }
            }
          }
        };
        copyHTMLNodeIntoAnother('.evolution-chart-modal .chartter .chart-wrapper #chart-indicators', '.evolution-chart-exporter', chartConfig, {
          width,
          height
        });
        options['containerClass'] = '.evolution-chart-exporter';
        options['backgroundColor'] = exportEngine.theme?.background;
        options['exportSize'] = {
          width,
          height
        };
        await this.copyChart(options);
      } catch (error) {
        console.error("Error during chart copy:", error);
      } finally {
        window.$bus.trigger("showSuccess", {
          visible: true,
          message: "Copied image successfully",
          dismissSecs: 2
        });
        this.exporting = false;
      }
    }
  }
};